import { apiService, ApiResponse } from './api';
import { API_ENDPOINTS } from '../constants';

// Types
export interface Country {
  id: string;
  name: string;
  code: string;
  flag: string;
  flagEmoji?: string;
  region: string;
  isActive: boolean;
}

export interface VisaType {
  id: string;
  name: string;
  code: string;
  description: string;
  duration: string;
  isMultipleEntry: boolean;
}

export interface VisaRequirement {
  id: string;
  fromCountry: string;
  toCountry: string;
  visaType: string;
  isRequired: boolean;
  processingTime: string;
  fee: number;
  documents: string[];
  notes?: string;
}

export interface VisaCheckRequest {
  fromCountry: string;
  toCountry: string;
  visaType?: string;
  purpose?: string;
  duration?: number;
}

export interface VisaCheckResponse {
  isRequired: boolean;
  visaType: string;
  processingTime: string;
  fee: number;
  documents: string[];
  requirements: VisaRequirement[];
  recommendations?: string[];
}

// Visa Service Class
class VisaService {
  // Get all countries
  async getCountries(): Promise<ApiResponse<Country[]>> {
    return apiService.get<Country[]>(API_ENDPOINTS.COUNTRIES);
  }

  // Get visa types
  async getVisaTypes(): Promise<ApiResponse<VisaType[]>> {
    return apiService.get<VisaType[]>(API_ENDPOINTS.VISA_TYPES);
  }

  // Check visa requirements
  async checkVisaRequirements(request: VisaCheckRequest): Promise<ApiResponse<VisaCheckResponse>> {
    return apiService.post<VisaCheckResponse>(API_ENDPOINTS.VISA_REQUIREMENTS, request);
  }

  // Get visa policies for a specific route
  async getVisaPolicies(fromCountry: string, toCountry: string): Promise<ApiResponse<VisaRequirement[]>> {
    return apiService.get<VisaRequirement[]>(
      `${API_ENDPOINTS.VISA_POLICIES}?from=${fromCountry}&to=${toCountry}`
    );
  }

  // Get popular destinations
  async getPopularDestinations(): Promise<ApiResponse<Country[]>> {
    return apiService.get<Country[]>(`${API_ENDPOINTS.COUNTRIES}/popular`);
  }

  // Search countries
  async searchCountries(query: string): Promise<ApiResponse<Country[]>> {
    return apiService.get<Country[]>(`${API_ENDPOINTS.COUNTRIES}/search?q=${encodeURIComponent(query)}`);
  }
}

export const visaService = new VisaService();
